import React from 'react';
import { TColorRole, colorMap } from '../../../types/types';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { Spacing } from '../../layout/Spacing/Spacing';

interface IBadgeProps {
    label: string;
    color?: TColorRole;
    radius?: 's' | 'm';
    fontSize?: number;
}

    export const Badge: React.FC<IBadgeProps> = ({ label, color = 'dark', radius='m', fontSize = 1.2}) => {
    const hexColor = colorMap[color] || colorMap['dark'];
    return (
        <FlexCenter>
            <div className={`badge badge__radius--${radius}`} style={{ backgroundColor: `${hexColor}`, fontSize:`${fontSize}rem` }}>
                {label}
            </div>
        </FlexCenter>
    );
};
